const ctrlBtn = false;
export const siteKey = "0x4AAAAAAAJZvx-Brhy0ntsd";
export const isProduction = ctrlBtn && window.sysEnv === "production";
